import React from 'react';
import { FileText } from 'lucide-react';

const ReceiptDetail = ({ transaction, amount, onContinue, config }) => (
  <div className={`bg-white text-gray-800 h-full flex flex-col items-center justify-center p-3 ${config.ui.maxWidth} mx-auto`}>
    <FileText className="w-12 h-12 text-blue-600 mb-4" />
    <div className="text-lg font-bold text-gray-800 mb-4">Receipt Printing</div>
    <div className="bg-white border-2 border-dashed border-gray-400 p-4 rounded-lg w-full mb-6 shadow-lg">
      <div className="text-center space-y-2 text-black text-sm font-mono">
        <div className="font-bold text-base">MERCHANT RECEIPT</div>
        <div>{'='.repeat(30)}</div>
        <div className="text-left space-y-1 mt-4">
          <div>DATE: {new Date().toLocaleDateString()}</div>
          <div>TIME: {new Date().toLocaleTimeString()}</div>
          <div>CARD: ****1234</div>
          <div>TYPE: SALE</div>
          <div>AMOUNT: ${amount || '0.00'}</div>
          <div>APPROVAL: 123456</div>
          <div>REF: {Math.random().toString(36).substr(2, 8).toUpperCase()}</div>
        </div>
        <div className="mt-4">{'='.repeat(30)}</div>
        <div className="text-xs mt-2">THANK YOU FOR YOUR BUSINESS</div>
      </div>
    </div>
    <button 
      onClick={onContinue}
      className="px-6 py-2 bg-blue-600 text-white font-bold rounded-lg hover:bg-blue-700 transition-colors text-sm"
    >
      CONTINUE
    </button>
  </div>
);

export default ReceiptDetail;